import script from "./MessagePopup.vue?vue&type=script&setup=true&lang=js"
export * from "./MessagePopup.vue?vue&type=script&setup=true&lang=js"

import "./MessagePopup.vue?vue&type=style&index=0&id=6838c54e&scoped=true&lang=css"

import exportComponent from "/trc/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6838c54e"]])

export default __exports__